import OptionsProfitCalculatorStrategy from './OptionsProfitCalculatorStrategy';

export default OptionsProfitCalculatorStrategy;
